const autoNgTemplateLoaderTemplate1 = require('./views/containerinstances/containerinstances.html');
const autoNgTemplateLoaderTemplate2 = require('./views/containerinstances/create/createcontainerinstance.html');
const autoNgTemplateLoaderTemplate3 = require('./views/dashboard/dashboard.html');

angular.module('shbdeployer.azure', ['shbdeployer.app']).config([
  '$stateRegistryProvider',
  function ($stateRegistryProvider) {
    'use strict';

    var azure = {
      name: 'azure',
      url: '/azure',
      parent: 'endpoint',
      abstract: true,
      onEnter: /* @ngInject */ function onEnter($async, $state, endpoint, EndpointProvider, Notifications, StateManager) {
        return $async(async () => {
          if (endpoint.Type !== 3) {
            $state.go('shbdeployer.home');
            return;
          }
          try {
            EndpointProvider.setEndpointID(endpoint.Id);
            EndpointProvider.setEndpointPublicURL(endpoint.PublicURL);
            EndpointProvider.setOfflineModeFromStatus(endpoint.Status);
            await StateManager.updateEndpointState(endpoint, []);
          } catch (e) {
            Notifications.error('Не удалось загрузить окружение', e);
            $state.go('shbdeployer.home', {}, { reload: true });
          }
        });
      },
    };

    var containerInstances = {
      name: 'azure.containerinstances',
      url: '/containerinstances',
      views: {
        'content@': {
          templateUrl: autoNgTemplateLoaderTemplate1,
          controller: 'AzureContainerInstancesController',
        },
      },
    };

    var containerInstance = {
      name: 'azure.containerinstances.container',
      url: '/:id',
      views: {
        'content@': {
          component: 'containerInstanceDetails',
        },
      },
    };

    var containerInstanceCreation = {
      name: 'azure.containerinstances.new',
      url: '/new/',
      views: {
        'content@': {
          templateUrl: autoNgTemplateLoaderTemplate2,
          controller: 'AzureCreateContainerInstanceController',
        },
      },
    };

    var dashboard = {
      name: 'azure.dashboard',
      url: '/dashboard',
      views: {
        'content@': {
          templateUrl: autoNgTemplateLoaderTemplate3,
          controller: 'AzureDashboardController',
        },
      },
    };

    $stateRegistryProvider.register(azure);
    $stateRegistryProvider.register(containerInstances);
    $stateRegistryProvider.register(containerInstance);
    $stateRegistryProvider.register(containerInstanceCreation);
    $stateRegistryProvider.register(dashboard);
  },
]);
